document.addEventListener("turbo:load", function() {
  const ALLOWED_TYPES = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "image/jpeg",
    "image/png"
  ];

  function showFileError(message) {
    $("#js-cv-parser-errors").find("ul").append(`<li>${message}</li>`);
    $("#js-cv-parser-errors").show();
  }

  function handleFileSelected(file) {
    if (!file) return false;

    if (!ALLOWED_TYPES.includes(file.type)) {
      showFileError("Bitte laden Sie eine PDF-, Word-, JPG- oder PNG-Datei hoch.");
      return false;
    }

    const $label = $(".cv-parser-upload__label");
    const $container = $("#js-cv-parser-file-container");
    const $span = $("<span>").addClass("cv-parser-upload__label-text").attr("id", "file-uploaded").css({ "font-weight": "bold", "margin-bottom": "0" }).text(file.name);
    $container.empty().append($span);
    $label.css("border-color", "#66AE9B");
    $label.css("background", "#e0efec");
    return true;
  }

  // File Upload Handler
  $("#js-cv-parser-file-field").on("change", function () {
    if (this.files && this.files[0]) {
      const accepted = handleFileSelected(this.files[0]);
      if (!accepted) this.value = "";
    }
  });

  // Drag and Drop Handler
  const dropzone = $(".cv-parser-upload__label")[0];

  if (dropzone) {
    let dragCounter = 0;

    dropzone.addEventListener("dragenter", function (e) {
      e.preventDefault();
      dragCounter++;
      $(this).css("border-color", "#66AE9B");
      $(this).css("background", "#e0efec");
    });

    dropzone.addEventListener("dragover", function (e) {
      e.preventDefault();
    });

    dropzone.addEventListener("dragleave", function (e) {
      dragCounter--;
      if (dragCounter === 0) {
        $(this).css("border-color", "");
        $(this).css("background", "");
      }
    });

    dropzone.addEventListener("drop", function (e) {
      e.preventDefault();
      dragCounter = 0;
      $(this).css("border-color", "");
      $(this).css("background", "");
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        const accepted = handleFileSelected(files[0]);
        if (accepted) {
          const fileInput = $("#js-cv-parser-file-field")[0];
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(files[0]);
          fileInput.files = dataTransfer.files;
        }
      }
    });
  }

  // Form Submit Handler
  $("#landingpage-form").on("submit", function (e) {
    $("#js-cv-parser-errors").hide().find("ul").empty();

    let hasErrors = false;
    const errors = [];

    const fileInput = $("#js-cv-parser-file-field")[0];
    if (!fileInput.files || !fileInput.files[0]) {
      hasErrors = true;
      errors.push("Bitte laden Sie einen Lebenslauf hoch.");
    }

    if (!$("#js-cv-parser-tos").is(":checked")) {
      hasErrors = true;
      errors.push("Bitte akzeptieren Sie die Datenschutzbestimmungen.");
    }

    if (hasErrors) {
      e.preventDefault();
      errors.forEach(function(error) {
        showFileError(error);
      });

      $('html, body').animate({
        scrollTop: $("#landingpage-form").offset().top - 100
      }, 500);

      return false;
    }

    $(".cv-parser-upload__submit-button").prop("disabled", true).css("opacity", "0.5");
    $("#spinner-cv-parser").addClass("active").html(`
      <div class="cv-parser-upload__loading">
        <i class="fas fa-spinner fa-spin cv-parser-upload__loading-spinner"></i>
        <p class="cv-parser-upload__loading-text">Ihre Daten werden verarbeitet, bitte warten Sie einen kleinen Moment.</p>
      </div>
    `);
  });
})
